import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Command as CommandIcon, Plus, Users, LayoutDashboard, Settings, Receipt } from "lucide-react";
import { api } from "@/lib/api";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";

export const CommandPalette = ({ open, setOpen }) => {
  const nav = useNavigate();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    if (open) {
      api.get("/groups").then(({ data }) => setGroups(data)).catch(() => {});
    }
  }, [open]);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [setOpen]);

  const go = (path) => {
    setOpen(false);
    nav(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search or run a command…" data-testid="cmdk-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go("/groups")} data-testid="cmdk-new-group">
            <Plus className="h-4 w-4 mr-2" strokeWidth={1.5} />
            New group
          </CommandItem>
          <CommandItem onSelect={() => go("/dashboard")} data-testid="cmdk-dashboard">
            <LayoutDashboard className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Open Dashboard
          </CommandItem>
          <CommandItem onSelect={() => go("/groups")} data-testid="cmdk-groups">
            <Users className="h-4 w-4 mr-2" strokeWidth={1.5} />
            All Groups
          </CommandItem>
          <CommandItem onSelect={() => go("/settings")} data-testid="cmdk-settings">
            <Settings className="h-4 w-4 mr-2" strokeWidth={1.5} />
            Settings
          </CommandItem>
        </CommandGroup>
        {groups.length > 0 && (
          <>
            <CommandSeparator />
            <CommandGroup heading="Your groups">
              {groups.map((g) => (
                <CommandItem key={g.id} onSelect={() => go(`/groups/${g.id}`)} data-testid={`cmdk-group-${g.id}`}>
                  <span className="mr-2">{g.emoji}</span>
                  {g.name}
                </CommandItem>
              ))}
            </CommandGroup>
            <CommandSeparator />
            <CommandGroup heading="Add a bill">
              {groups.map((g) => (
                <CommandItem key={`b-${g.id}`} onSelect={() => go(`/groups/${g.id}/bills/new`)} data-testid={`cmdk-add-bill-${g.id}`}>
                  <Receipt className="h-4 w-4 mr-2" strokeWidth={1.5} />
                  New bill in {g.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </>
        )}
      </CommandList>
    </CommandDialog>
  );
};
